import { FC } from 'react';
import styles from './LanguageModal.module.css';
import { Modal } from '../Modal';
import { FormattedMessage } from 'react-intl';
import { Card } from '../Card';
import { setLanguage, useLanguage, useLanguages } from '../../i18n';
import clsx from 'clsx';

interface LanguageModalProps {
  open?: boolean;
  onClose?: () => void;
}

export const LanguageModal: FC<LanguageModalProps> = (props) => {
  const languages = useLanguages();
  const current = useLanguage();
  return (
    <Modal title={<FormattedMessage id="Language.Choose" />} {...props}>
      <div className={styles.container}>
        <div className={styles.list}>
          {languages.map(({ code, language }) => (
            <Card
              key={code}
              className={clsx(styles.languageCard, {
                [styles.active]: code === current,
              })}
              onClick={() => {
                setLanguage(code);
                props.onClose?.();
              }}
            >
              <div className={styles.languageCardTitle}>
                {language}
                <div className={styles.circle} />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </Modal>
  );
};
